const DEFAULT_ORDERED_PARTS_COLUMNS = [
  {
    id: "ordered_date",
    label: "Ordered Date",
    editable: true,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "po_number",
    label: "PO Number",
    editable: true,
    type: "string",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "tickets",
    label: "Tickets",
    sortable: false,
    type: "array",
    width: "300",
    show: true,
    resizable: true,
  },
  {
    id: "status",
    label: "Current Status",
    editable: true,
    type: "selection",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "description",
    label: "Part Description",
    editable: true,
    type: "string",
    width: "250",
    show: true,
    resizable: true,
  },
  {
    id: "quantity",
    label: "Quantity",
    editable: true,
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "each_price",
    label: "Each Price",
    editable: true,
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "vendor",
    label: "Vendor",
    editable: true,
    type: "string",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "eta",
    label: "ETA",
    editable: true,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "tracking_number",
    label: "Tracking",
    editable: true,
    type: "string",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "created_at",
    label: "Created",
    sortable: true,
    type: "datetime",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "updated_at",
    label: "Updated",
    sortable: true,
    type: "datetime",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "vendor_part_number",
    label: "Vendor Part #",
    sortable: true,
    type: "string",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "shipping_price",
    label: "Shipping Price",
    editable: true,
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "total_price",
    label: "Total Price",
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "payment_method",
    label: "Payment Method",
    editable: true,
    type: "selection",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "received_date",
    label: "Received Date",
    editable: true,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "notes",
    label: "Notes",
    editable: true,
    type: "string",
    width: "300",
    show: true,
    resizable: true,
  },
  {
    id: "name",
    label: "Name",
    editable: true,
    type: "string",
    width: "150",
    show: true,
    resizable: true,
  },
];

export default DEFAULT_ORDERED_PARTS_COLUMNS;
